/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Clubs_Round_LabelInputs */

const en_us2_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Round ${i?.number}`)
};

const pt_br2_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rodada ${i?.number}`)
};

const es_419_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ronda ${i?.number}`)
};

const pt_pt2_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ronda ${i?.number}`)
};

const fr_fr2_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manche ${i?.number}`)
};

const de_de2_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Runde ${i?.number}`)
};

const it_it2_clubs_round_label = /** @type {(inputs: Clubs_Round_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Turno ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Round {number}" |
*
* @param {Clubs_Round_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_round_label = /** @type {((inputs: Clubs_Round_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Round_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_round_label(inputs)
	if (locale === "es-419") return es_419_clubs_round_label(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_round_label(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_round_label(inputs)
	if (locale === "de-DE") return de_de2_clubs_round_label(inputs)
	if (locale === "it-IT") return it_it2_clubs_round_label(inputs)
	return en_us2_clubs_round_label(inputs)
});
export { clubs_round_label as "clubs.round_label" }